import { render, staticRenderFns } from "./ProgramDemoCard.vue?vue&type=template&id=d412fba2&scoped=true"
import script from "./ProgramDemoCard.vue?vue&type=script&lang=ts"
export * from "./ProgramDemoCard.vue?vue&type=script&lang=ts"
import style0 from "./ProgramDemoCard.vue?vue&type=style&index=0&id=d412fba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d412fba2",
  null
  
)

export default component.exports